import React from 'react';
import { Item, SelectableItemProps } from 'components/Item';
import { FolderViewMode } from 'components/FolderViewer/FolderViewModeContext';
import { ItemMenu_node$key } from '../../Item/ItemMenu/__generated__/ItemMenu_node.graphql';
import { UploadingHandleProps } from 'components/ItemHandle/components/UploadingHandle';
import { useItemHandleFragmentProps } from 'components/ItemHandle';
import { DateSortOption } from '..';

type FolderItemProps = SelectableItemProps & {
  node?: ItemMenu_node$key & useItemHandleFragmentProps['item'];
  name?: string;
  isLoading?: boolean;
  loadingPercentage?: number;
  isFailed?: boolean;
  isVirus?: boolean;
  uploadError?: string;
  parentConnectionId?: string;
  cancelUpload?: () => void;
  retryUpload?: () => void;
  viewMode: FolderViewMode;
  dateColumn?: DateSortOption;
};

export default function FolderItem({
  node,
  name,
  isLoading,
  loadingPercentage,
  isFailed,
  isVirus,
  uploadError,
  cancelUpload,
  viewMode,
  parentConnectionId,
  ...props
}: FolderItemProps) {
  return (
    <Item
      node={node}
      uploadName={name || ''}
      isLoading={!!isLoading}
      loadingPercentage={loadingPercentage || (isLoading ? 0 : 100)}
      isFailed={isFailed || false}
      isVirus={isVirus || false}
      uploadError={uploadError}
      cancelUpload={cancelUpload}
      viewMode={viewMode}
      parentConnectionId={parentConnectionId}
      {...props}
    />
  );
}

type LoadingFolderItemProps = {
  name: string;
  isLoading: boolean;
  loadingPercentage: number;
  parentConnectionId?: string;
  cancelUpload: () => void;
  viewMode: FolderViewMode;
};

export const LoadingFolderItem = (props: LoadingFolderItemProps) => {
  return <FolderItem {...props} />;
};

type FailedFolderItemProps = UploadingHandleProps & {
  parentConnectionId?: string;
  viewMode: FolderViewMode;
};

export const FailedFolderItem = (props: FailedFolderItemProps) => {
  return <FolderItem {...props} />;
};
